import {
  GET_DASHBOARD,
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_FAILURE,
} from 'store/dashboard/dashboardAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD:
      return { ...state, loading: true };
    case GET_DASHBOARD_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_DASHBOARD_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getDashboardReducer;
